/**
 * Open Dropdown on "hover" by simulating a real "click"
 * Fixes stuck :focus/:active states after hiding
 */

export default (() => {
  if (!('ontouchstart' in window) && !navigator.maxTouchPoints) {
    document
      .querySelectorAll('[data-bs-toggle="dropdown"][data-bs-trigger="hover"]')
      .forEach((trigger) => {
        const parent = trigger.closest('.dropdown')
        const dropdown = bootstrap.Dropdown.getOrCreateInstance(trigger) // eslint-disable-line no-undef
        let closeTimeout

        // Hover to show dropdown
        parent.addEventListener('mouseenter', () => {
          clearTimeout(closeTimeout)
          if (!parent.classList.contains('show')) {
            trigger.dispatchEvent(new MouseEvent('click', { bubbles: true }))
          }
        })

        // Mouse leaves dropdown — hide with delay
        parent.addEventListener('mouseleave', () => {
          closeTimeout = setTimeout(() => {
            dropdown.hide()

            // Удаляем фокус и активные состояния
            trigger.blur()
            trigger.classList.remove('show', 'active')
            parent.classList.remove('show')
          }, 150)
        })

        // Prevent default for "#" and remove focus
        trigger.addEventListener('click', (e) => {
          if (e.currentTarget.getAttribute('href') === '#') {
            e.preventDefault()
          }
          trigger.blur()
        })

        // Escape closes dropdown and resets button state
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            dropdown.hide()
            trigger.blur()
            trigger.classList.remove('show', 'active')
            parent.classList.remove('show')
          }
        })
      })
  }
})()
